import {
  FaReact,
  FaNodeJs,
  FaDocker,
  FaAws,
  FaMicrosoft,
  FaJava,
  FaGithub,
  FaCode,
} from "react-icons/fa";
import {
  SiTypescript,
  SiNextdotjs,
  SiRedux,
  SiTailwindcss,
  SiChakraui,
  SiMui,
  SiNestjs,
  SiExpress,
  SiPostgresql,
  SiRedis,
  SiSocketdotio,
  SiRabbitmq,
  SiCypress,
  SiPrometheus,
  SiGrafana,
  SiPostman,
  SiKubernetes,
  SiMongodb,
} from "react-icons/si";
import { BiLogoVisualStudio } from "react-icons/bi";
import { CgFramer } from "react-icons/cg";
import { IoGameControllerOutline } from "react-icons/io5";
import { MdOutlineSportsFootball } from "react-icons/md";
import { FaJenkins } from "react-icons/fa";
import { PiOpenAiLogoThin } from "react-icons/pi";  
import { SiHuggingface } from "react-icons/si";
import { RiAiGenerate2 } from "react-icons/ri";
import { BsDatabaseFill } from "react-icons/bs";

export const skills = [
  {
    name: "React.js",
    icon: <FaReact />,
    color: "#0096C7",
    company: ["9x", "wipro"],
  },
  {
    name: "TypeScript",
    icon: <SiTypescript />,
    color: "#3178C6",
    company: ["9x", "wipro"],
  },
  { name: "Node.js", icon: <FaNodeJs />, color: "#339933", company: ["9x"] },
  {
    name: "MongoDB",
    icon: <SiMongodb />,
    color: "#47A248",
    company: ["9x", "wipro"],
  },

  { name: "Next.js", icon: <SiNextdotjs />, color: "#000000", company: ["9x"] },
  { name: "NestJS", icon: <SiNestjs />, color: "#E0234E", company: ["9x"] },
  {
    name: "Express.js",
    icon: <SiExpress />,
    color: "#000000",
    company: ["9x", "wipro"],
  },
  {
    name: "PostgreSQL",
    icon: <SiPostgresql />,
    color: "#336791",
    company: ["9x", "wipro"],
  },
  {
    name: "Redis",
    icon: <SiRedis />,
    color: "#DC382D",
    company: ["9x", "wipro"],
  },
  {
    name: "Docker",
    icon: <FaDocker />,
    color: "#2496ED",
    company: ["9x", "wipro"],
  },
  {
    name: "AWS EC2",
    icon: <FaAws />,
    color: "#FF9900",
    company: ["9x", "wipro"],
  },
  {
    name: "Tailwind CSS",
    icon: <SiTailwindcss />,
    color: "#0096C7",
    company: ["9x", "wipro"],
  },
  {
    name: "Jenkins",
    icon: <FaJenkins />,
    color: "#D24939",
    company: ["9x"],
  },
  {
    name: "Redux Toolkit",
    icon: <SiRedux />,
    color: "#764ABC",
    company: ["9x", "wipro"],
  },
  {
    name: "Chakra UI",
    icon: <SiChakraui />,
    color: "#319795",
    company: ["9x"],
  },
  { name: "Material UI", icon: <SiMui />, color: "#0081CB", company: ["9x"] },
  { name: "Java", icon: <FaJava />, color: "#ED8B00", company: ["wipro"] },
  { name: "AWS S3", icon: <FaAws />, color: "#FF9900", company: ["9x"] },
  { name: "AWS SQS", icon: <FaAws />, color: "#FF9900", company: ["9x"] },
  { name: "AWS EKS", icon: <FaAws />, color: "#FF9900", company: ["9x"] },
  {
    name: "Kubernetes",
    icon: <SiKubernetes />,
    color: "#326CE5",
    company: ["9x"],
  },
  {
    name: "GitHub CI/CD",
    icon: <FaGithub />,
    color: "#181717",
    company: ["9x", "wipro"],
  },
  {
    name: "Azure Repos",
    icon: <FaMicrosoft />,
    color: "#0078D4",
    company: ["9x", "wipro"],
  },
  {
    name: "REST APIs",
    icon: <FaCode />,
    color: "#FF6B6B",
    company: ["9x", "wipro"],
  },
  {
    name: "Websocket Gateways",
    icon: <SiSocketdotio />,
    color: "#010101",
    company: ["9x", "wipro"],
  },
  {
    name: "Socket.io",
    icon: <SiSocketdotio />,
    color: "#010101",
    company: ["9x", "wipro"],
  },
  {
    name: "Redis Pub/Sub",
    icon: <SiRedis />,
    color: "#DC382D",
    company: ["9x", "wipro"],
  },
  {
    name: "RabbitMQ",
    icon: <SiRabbitmq />,
    color: "#FF6600",
    company: ["9x", "wipro"],
  },
  {
    name: "Cypress",
    icon: <SiCypress />,
    color: "#17202C",
    company: ["wipro"],
  },
  {
    name: "Prometheus",
    icon: <SiPrometheus />,
    color: "#E6522C",
    company: ["9x"],
  },
  { name: "Grafana", icon: <SiGrafana />, color: "#F46800", company: ["9x"] },
  { name: "Filebeat", icon: <FaCode />, color: "#005571", company: ["9x"] },
  {
    name: "Postman",
    icon: <SiPostman />,
    color: "#FF6C37",
    company: ["9x", "wipro"],
  },
  {
    name: "VS Code",
    icon: <BiLogoVisualStudio />,
    color: "#007ACC",
    company: ["9x", "wipro"],
  },
  {
    name: "Agile",
    icon: <FaCode />,
    color: "#4A90E2",
    company: ["9x", "wipro"],
  },
  {
    name: "Scrum",
    icon: <FaCode />,
    color: "#7B68EE",
    company: ["9x", "wipro"],
  },
  {
    name: "Framer Motion",
    icon: <CgFramer />,
    color: "#E69B00",
    company: ["9x"],
  },
  {
    name: "iGaming",
    icon: <IoGameControllerOutline />,
    color: "#15C997",
    company: ["9x"],
  },
  {
    name: "SportsBook",
    icon: <MdOutlineSportsFootball />,
    color: "#F1C232",
    company: ["9x"],
  },
  {
    name: "OpenAI(Embedding)",
    icon: <PiOpenAiLogoThin />,
    color: "#000000",
    company: ["9x"],
  },
  {
    name: "OpenAI(LLM)",
    icon: <PiOpenAiLogoThin />,
    color: "#000000",
    company: ["9x"],
  },
  {
    name: "Hugging Face",
    icon: <SiHuggingface />,
    color: "#FF9900",
    company: ["9x"],
  },
  {
    name: "RAG",
    icon: <RiAiGenerate2 />,
    color: "#764ABC",
    company: ["9x"],
  },
  {
    name: "Pinecone",
    icon: <BsDatabaseFill />,
    color: "#764ABC",
    company: ["9x"],
  },
];
